import { navigate } from "../router.jsx";

/* ============================================================
   Talention — Rutas del SVPT embebido
   Las pantallas del prototipo navegan con rutas cortas ("/valuation/3").
   Aquí se les antepone el prefijo del apartado: sin él aterrizarían en las
   pantallas del motor de valoración real, que usan los mismos nombres.
   ============================================================ */

const BASE = "/svpt";

function go(ruta) {
  navigate(BASE + ruta);
}

export { BASE, go };
